import { BOARDS_BEYOND_FALLBACK_SSO_URL } from '../../../common/constants/professional-redirects';
import { ariaLabelWithNewTab } from '../../../common/utils/a11y-util';
import { OrderHistory as IOrderHistory, UserOrderDetails } from '../../order-history/order-history.interface';
import { html, TemplateResult } from 'lit';
import { mhecommLocalStorage } from '../../../common/local-storage';

export const CID_BOARDS_AND_BEYOND_KEY = 'CID_BOARDS_BEYOND';
export const CID_BOARDS_AND_BEYOND_VALUE = 'aff|PROF|BandB to FA4||clicks|';

export const BOARDS_AND_BEYONDS_LAUNCH_CTA_LABEL = 'Launch Boards and Beyond';

export function saveCIDBoardsBeyondsOnLocalStorage(): void {
  if (extractCIDFromURL() === CID_BOARDS_AND_BEYOND_VALUE) {
    mhecommLocalStorage.set(CID_BOARDS_AND_BEYOND_KEY, 'true', 30);
  }
}

export function removeCIDBoardsBeyondsFromLocalStorage(): void {
  mhecommLocalStorage.remove(CID_BOARDS_AND_BEYOND_KEY);
}

export function isBoardsBeyond(): boolean {
  return mhecommLocalStorage.get(CID_BOARDS_AND_BEYOND_KEY) === 'true';
}

function extractCIDFromURL(): string {
  const cid = new URL(document.referrer)?.searchParams.get('cid');
  return decodeURI(cid ?? '');
}

/**
 * Boards Beyond CTA for digital products and order history sections
 *
 * @param order
 * @param userOrderDetails
 * @param analyticsCallback
 */
export function boardsBeyondCTA(
  order: IOrderHistory,
  userOrderDetails: UserOrderDetails,
  analyticsCallback: Function
): TemplateResult {
  return html` <a
    class="btn btn-outline-primary w-100 w-lg-75"
    aria-label="${ariaLabelWithNewTab('BoardsBeyond App')}"
    target="_blank"
    data-automation-id="btn-launch-${order.webOrderNo}-${userOrderDetails.isbn10}"
    @click=${(event: Event): void => openBoardsBeyond(event, order, userOrderDetails, analyticsCallback)}
    href=${getBoardsBeyondLaunchUrl(userOrderDetails.boardsBeyondUrl)}
  >
    ${BOARDS_AND_BEYONDS_LAUNCH_CTA_LABEL}&nbsp;
    <uxt-icon icon="box-arrow-up-right"></uxt-icon>
  </a>`;
}

/**
 * Returns the Boards and Beyond launch URL if it exists
 *
 * Otherwise, it returns the fallback SSO URL for backward compatibility
 *
 * @param boardsBeyondLaunchUrl
 */
export function getBoardsBeyondLaunchUrl(boardsBeyondLaunchUrl?: string): string {
  return boardsBeyondLaunchUrl ?? BOARDS_BEYOND_FALLBACK_SSO_URL;
}

/**
 * Opens Boards Beyond in a new window
 *
 * @param event
 * @param order
 * @param userOrderDetails
 * @param analyticsCallback
 */
function openBoardsBeyond(
  event: Event,
  order: IOrderHistory,
  userOrderDetails: UserOrderDetails,
  analyticsCallback: Function
): void {
  event?.preventDefault();

  const boardsBeyondUrl = getBoardsBeyondLaunchUrl(userOrderDetails.boardsBeyondUrl);
  analyticsCallback('go-to-boards-beyond', 'Launch', order, userOrderDetails, boardsBeyondUrl);
  window.open(boardsBeyondUrl);
}
